import React from "react";
import {
  ActionIcon,
  Avatar,
  Box,
  Container,
  Grid,
  Indicator,
  Tabs,
  Text,
  TextInput,
} from "@mantine/core";
import {
  IconBell,
  IconSettings,
  IconSquareRoundedChevronLeft,
  IconSearch,
} from "@tabler/icons-react";
import useStyles from "./style";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaArrowLeftLong } from "react-icons/fa6";

const Topbar = (props) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { notiCount } = useSelector((state) => state.notification);
  const {
    title,
    back,
    populateName,
    initialValues,
    backAllClients,
    populateFacility,
    onEditFacilityClick,
  } = props;
  return (
    <Container className={classes.wrapper} fluid p={0}>
      <Box style={{ width: "100%", margin: "0 20px" }}>
        {backAllClients && (
          <Box className={classes.backAllClients} onClick={backAllClients}>
            <FaArrowLeftLong color="var(--app-primary)" size={20} />
            <Text color="var(--app-text)">All Clients</Text>
          </Box>
        )}

        <Box className={classes.leftSide}>
          <Text className={classes.myfont} data-testid="dashboard-title">
            {back && (
              <IconSquareRoundedChevronLeft
                size={30}
                onClick={() => navigate(back)}
              />
            )}
            {title}
          </Text>
        </Box>
        <Grid>
          <Grid.Col span={12} sm={2}>
            <Text fz={26} c="var(--app-text-muted)">
              {populateName ? populateName : initialValues?.name}
            </Text>
          </Grid.Col>
          {(populateFacility || initialValues) && (
            <Grid.Col span={12} sm={7} className={classes.facilityBox}>
              <Box className={classes.facilityContainer}>
                <Text fz={24} c="var(--app-text-muted)">
                  Facility:
                </Text>
                {initialValues?.facilityId
                  ? initialValues?.facilityId?.map((facility, index) => (
                      <Text
                        fz={16}
                        c="var(--app-text)"
                        key={index}
                        className={classes.facility}
                      >
                        {facility?.name || "No facility"}
                      </Text>
                    ))
                  : populateFacility?.map((facility, index) => (
                      <Text
                        fz={16}
                        c="var(--app-text)"
                        key={index}
                        className={classes.facility}
                      >
                        {facility?.name || "No facility"}
                      </Text>
                    ))}
              </Box>
              <Text
                fz={16}
                c="var(--app-text)"
                style={{ cursor: "pointer" }}
                onClick={onEditFacilityClick}
              >
                Edit
              </Text>
            </Grid.Col>
          )}
        </Grid>
      </Box>
      <Box className={classes.rightIcons}>
        <NavLink to={"/home/settings"}>
          <span
            className={`${classes.float_right} ${classes.settingBGcolor}`}
            style={{
              background: window.location.pathname.includes("settings")
                ? "var(--app-primary)"
                : "var(--app-surface-2)",
            }}
          >
            <IconSettings
              size={30}
              className={classes.settingIcon}
              stroke={1}
              style={{
                color: window.location.pathname.includes("settings")
                  ? "var(--app-on-primary)"
                  : "var(--app-text)",
              }}
            />
          </span>
        </NavLink>

        {/* 
        <Box className={classes.bellMarginRight}>
          {window.location.pathname.includes("/home/notifications") ? (
            <>
              <Box className={classes.clickedBell}>
                <NavLink to={"/home/notifications"}>
                  <IconBell color="white" size={25} />
                </NavLink>
              </Box>
            </>
          ) : (
            <NavLink to={"/home/notifications"}>
              <Indicator label={notiCount} size={16} styles={{ indicator: { backgroundColor: "var(--app-primary)", color: "var(--app-on-primary)" } }}>
                <Avatar
                  color={"gray"}
                  className={classes.avatarBorderRadius}
                  size="lg"
                  radius="sm"
                >
                  <IconBell size={24} />
                </Avatar>
              </Indicator>
            </NavLink>
          )}
        </Box> */}
      </Box>

      {/* <TextInput
        placeholder="Feature Coming Soon..."
        sx={{ fontFamily: "Inter", width: "30%", marginRight: ".5rem" }}
        icon={<IconSearch color="#232323" />}
        size="lg"
        radius={12}
        className={`${classes.float_right} ${classes.mobileScreen}`}
      /> */}
    </Container>
  );
};

export default Topbar;
